<template>
  <Tooltip side="bottom" :side-offset="8" :delay-duration="400">
    <router-link
      :to="{ name: 'workspace-projects' }"
      class="text-accent-400 hover:bg-neutral-50/[0.12] py-2 px-3 inline-flex"
    >
      <LayoutGrid class="size-6" />
    </router-link>
    <template #content>
      <p>Workspace</p>
    </template>
  </Tooltip>
</template>

<script setup>
import { LayoutGrid } from 'lucide-vue-next';
import { Tooltip } from '@ui/components/tooltip';
</script>
